import React, { useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { motion, AnimatePresence, useAnimation } from 'framer-motion';

const modalWrapVariants = {
  closed: {
    opacity: 0,
  },
  open: {
    opacity: 1,
  },
};

const modalInnerVariants = {
  closed: {
    opacity: 0,
    y: 100,
  },
  open: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      damping: 100,
      stiffness: 100,
    },
  },
};

const closeBtnVariants = {
  closed: {
    opacity: 0,
    y: 20,
  },
  open: {
    opacity: 1,
    y: 0,
  },
};

export const ReactModal = ({ parentNode, showModal, setShowModal, children, className }) => {
  const modalInnerEl = useRef(null);

  // const modalOpen = useAnimation();

  useEffect(() => {
    if (showModal) {
      disableBodyScroll(modalInnerEl.current);
    } else {
      enableBodyScroll(modalInnerEl.current);
    }
    return () => {
      enableBodyScroll(modalInnerEl.current);
    };
  }, [showModal]);

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={'closed'}
          animate={'open'}
          exit={'closed'}
          variants={modalWrapVariants}
          className={`Modal Modal--react ${className}`}
        >
          <motion.div
            initial={'closed'}
            animate={'open'}
            exit={'closed'}
            variants={modalInnerVariants}
            className="Modal__box"
            ref={modalInnerEl}
          >
            {children}
            <motion.button
              initial={'closed'}
              animate={'open'}
              exit={'closed'}
              variants={closeBtnVariants}
              className="Button close-modal"
              data-layout="noLayout"
              onClick={() => setShowModal(false)}
            >
              <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                <use xlinkHref="#close"></use>
              </svg>
            </motion.button>
          </motion.div>
          <span className="backdrop" onClick={() => setShowModal(false)}></span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
